<template lang="pug">
ul.pagination
  li.page-item(
    @click="addPage(-1)" 
    :class="{disabled: page === 1}"
  )
    .page-link 上一頁
  li.page-item(
    v-for="p in pages"
    :key="p"
    @click="setPage(p)"
    :class="{active: page === p}"
  )
    .page-link {{p}}
  li.page-item(
    @click="addPage(1)" 
    :class="{disabled: page === max}")
    .page-link 下一頁
</template>

<script>
export default {
  emits: ['update:page'],
  props: {
    max: {type: Number, default: 1},
    page: { type: Number, default: 1 }
  },
  computed: {
    pages () {
      return Array(this.max).fill(null).map((e,i) => +i+1)
    }
  },
  methods: {
    setPage(p){
      if(p === this.page) return
      this.$emit('update:page', p)
    },
    addPage(add){
      let page = +this.page + add
      page = page > +this.max ? +this.max : page < 1 ? 1 : page
      this.$emit('update:page', page)
    }
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/MyPagination.vue